/**
 * NO04 - Ordre Search Models
 */

export interface NO04SearchParams {
  companyId: string;
  // Quick search — set orderNumber + customerNumber to the same value + matchAnyNumber=true
  matchAnyNumber?: boolean;
  // Typed params (both quick search and advanced)
  orderNumber?: string;
  customerNumber?: string;
  requisitionNumber?: string;
  invoiceCreditNumber?: string;
  fromDate?: string;
  toDate?: string;
  page?: number;
  pageSize?: number;
}

export interface NO04Order {
  ordreNr: string;
  kundenr: string;
  navn: string;
  rekvNr: string;
  dato: string;
  tid: string;
  om: string;           // receiver
  status: string;
  antBestilt: number;
  antLevert: number;
  belop: number;
  brfProsent: number;   // grossProfit %
  faktura: string;      // invoiceCreditNumber
  fraktEdi: string;     // shippingNumber (tracking)
  ordreType: string;
  betalingsKode: string;
  sendeMote: string;    // shippingMethod
}

export default class NO04 implements NO04Order {
  ordreNr: string;
  kundenr: string;
  navn: string;
  rekvNr: string;
  dato: string;
  tid: string;
  om: string;
  status: string;
  antBestilt: number;
  antLevert: number;
  belop: number;
  brfProsent: number;
  faktura: string;
  fraktEdi: string;
  ordreType: string;
  betalingsKode: string;
  sendeMote: string;

  constructor(
    ordreNr = '',
    kundenr = '',
    navn = '',
    rekvNr = '',
    dato = '',
    tid = '',
    om = '',
    status = '',
    antBestilt = 0,
    antLevert = 0,
    belop = 0,
    brfProsent = 0,
    faktura = '',
    fraktEdi = '',
    ordreType = '',
    betalingsKode = '',
    sendeMote = '',
  ) {
    this.ordreNr = ordreNr;
    this.kundenr = kundenr;
    this.navn = navn;
    this.rekvNr = rekvNr;
    this.dato = dato;
    this.tid = tid;
    this.om = om;
    this.status = status;
    this.antBestilt = antBestilt;
    this.antLevert = antLevert;
    this.belop = belop;
    this.brfProsent = brfProsent;
    this.faktura = faktura;
    this.fraktEdi = fraktEdi;
    this.ordreType = ordreType;
    this.betalingsKode = betalingsKode;
    this.sendeMote = sendeMote;
  }
}

